<template>
  <div class="row justify-content-center">
    <div class="col-md-10 col-lg-8 col-xl-7 col-xxl-7 col-xxxl-7 maxWidthContainer">
      <div class="card border-0 rounded-0 bg-white authentication-card radius-7">
        <div class="card-body letter-spacing col-12">
          <div class="d-flex align-items-center flex-column">
            <img
              class="authentication-brand-lockup authentication-brand-lockup--compact"
              src="../../assets/branding/centrallize-light-lockup-clean.png"
              width="210"
              alt="Centrallize"
            >
            <h4 class="text-black fw-bold mb-0 text-center">
              Crie sua conta
            </h4>
          </div>
          <div class="register-trial-offer">
            <strong>Experimente grátis por 7 dias</strong>
            <span>Sem cartão e sem pagamento inicial. Comece a organizar seu estabelecimento hoje.</span>
          </div>
          <form ref="formRegister" @submit.prevent="submitRegister">
            <div class="row d-flex">
              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-12 col-xxxl-12">
                <label class="d-block text-black fw-semibold mb-10">Nome</label>
                <input
                  ref="name"
                  type="text"
                  name="name"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="Digite seu nome"
                  @keyup="changeInformationInputs('name')"
                />
              </div>

              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                <label class="d-block text-black fw-semibold mb-10">
                  Celular/Telefone
                </label>
                <input
                  ref="phone"
                  type="text"
                  name="phone"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="Digite o seu celular ou telefone"
                  @keyup="changeInformationInputs('phone')"
                  @input="applyMaskPhone"
                  maxlength="15"
                />
              </div>

              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                <label class="d-block text-black fw-semibold mb-10">
                  Cpf ou cnpj
                </label>
                <input
                  ref="cpf_cnpj"
                  type="text"
                  name="cpf_cnpj"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="Digite o seu cpf ou cnpj"
                  @keyup="changeInformationInputs('cpf_cnpj')"
                  @input="applyMaskCpfCnpj"
                  maxlength="18"
                />
              </div>

              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12">
                <label class="d-block text-black fw-semibold mb-10">
                  Email
                </label>
                <input
                  ref="email"
                  type="email"
                  name="email"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="Digite o seu email"
                  @keyup="changeInformationInputs('email')"
                />
              </div>

              <div v-if="availablePlans.length" class="form-group mb-15 mb-sm-20 mb-md-25 col-12">
                <div class="d-flex align-items-center justify-content-between mb-10">
                  <label class="d-block text-black fw-semibold mb-0">Plano</label>
                  <span class="plan-helper">Todos com 7 dias grátis</span>
                </div>

                <div class="register-plan-list">
                  <div
                    v-for="plan in availablePlans"
                    :key="plan.id || plan.name"
                    class="register-plan-option"
                    :class="{ active: String(selectedPlanId) === String(plan.id) }"
                  >
                    <label class="register-plan-selection">
                    <input
                      v-model="selectedPlanId"
                      type="radio"
                      name="subscription_plan_id"
                      :value="plan.id"
                    />
                    <span>
                      <strong>{{ plan.name || plan.title || 'Plano Centrallize' }}</strong>
                      <small>{{ formatPlanPrice(plan) }}{{ formatPlanBillingCycle(plan) }}</small>
                      <small v-if="String(plan.id) === String(recommendedPlanId)" class="text-success">Selecionado por padrão</small>
                    </span>
                    </label>
                    <button type="button" class="register-plan-details" :aria-label="`Saiba mais sobre ${plan.name}`" @click="detailsPlan = plan">Saiba mais</button>
                  </div>
                </div>
                <small class="d-block mt-2 text-muted">O valor mensal será cobrado no dia 1 seguinte ao fim do teste. Você pode mudar de plano dentro do app.</small>
              </div>
              <div v-if="loadingPlans" class="col-12 mb-3" role="status">Carregando planos...</div>
              <div v-else-if="!availablePlans.length" class="col-12 mb-3" role="alert">
                Não foi possível encontrar planos disponíveis.
                <button type="button" class="btn btn-link" @click="fetchRegisterPlans">Tentar novamente</button>
              </div>

              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                <label class="d-block text-black fw-semibold mb-10">
                  Senha
                </label>
                <input
                  ref="password"
                  type="password"
                  minlength="8"
                  autocomplete="new-password"
                  name="password"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="**************"
                  @keyup="changeInformationInputs('password')"
                />
              </div>

              <div class="form-group mb-15 mb-sm-20 mb-md-25 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                <label class="d-block text-black fw-semibold mb-10">
                  Confirme sua Senha
                </label>
                <input
                  ref="confirm_password"
                  type="password"
                  minlength="8"
                  autocomplete="new-password"
                  name="confirm_password"
                  class="form-control shadow-none rounded-0 text-black radius-7"
                  placeholder="**************"
                  @keyup="changeInformationInputs('confirm_password')"
                />
              </div>

              <div class="form-group col-12">
                <div ref="error_password_message" class="error-password-message">
                  As senhas são diferentes !
                </div>
              </div>
              
              <div class="form-group col-12">
                <div ref="error_password_message_caracters" class="error-password-message-caracters">
                  A senha precisa ter pelo menos 1 número e 1 caracter especial !
                </div>
              </div>

              <div
                class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1 mb-15 mb-md-20 col-12"
              >
                <label class="form-check-label" for="remember-me">
                  Cadastrar-se implica concordar com os
                  <a href="/terms" target="_blank" class="text-decoration-none">nossos termos</a>
                </label>
              </div>

              <div class="form-group col-12">
                <button
                  class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100"
                  type="submit"
                  ref="button_submit_register"
                  :disabled="loadingPlans || !selectedPlanId || submitting"
                >
                  {{ submitting ? 'Criando sua conta...' : 'Começar meu teste grátis' }}
                </button>
              </div>

              <div class="form-group col-12">
                <div class="message-error-register" v-if="getErrorRegister != ''">
                  {{ getErrorRegister }}
                </div>
              </div>

              <span
                class="d-block text-muted text-center mt-10 mt-md-30 mb-12 mb-md-20 fs-md-15 fs-lg-16"
              >
                Já possui uma conta?
              </span>

              <div class="form-group col-12">
                <router-link
                  to="/login"
                  class="default-btn with-border transition fw-medium rounded-1 fs-md-15 fs-lg-16 d-block w-100 text-decoration-none text-center"
                >
                  Entrar agora
                </router-link>
              </div>
            </div>
          </form>
          <PlanDetailsModal :plan="detailsPlan" @close="detailsPlan = null" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import api from "../../config/axios.js";
import PlanDetailsModal from './PlanDetailsModal.vue';

export default {
  name: "RegisterContent",
  components: { PlanDetailsModal },
  data() {
    return {
      selectedPlanId: null,
      registerPlans: [],
      loadingPlans: false,
      detailsPlan: null,
      submitting: false,
    };
  },
  computed:{
    ...mapGetters([
      'getErrorRegister'
    ]),
    availablePlans() {
      const payload = this.registerPlans;

      if (!payload) {
        return [];
      }

      if (Array.isArray(payload)) {
        return payload.filter((plan) => plan.available_for_purchase !== false);
      }

      if (Array.isArray(payload.data)) {
        return payload.data.filter((plan) => plan.available_for_purchase !== false);
      }

      if (Array.isArray(payload.plans)) {
        return payload.plans.filter((plan) => plan.available_for_purchase !== false);
      }

      return [];
    },
    recommendedPlanId() {
      return [...this.availablePlans].sort((a, b) => Number(b.price) - Number(a.price) || Number(a.id) - Number(b.id))[0]?.id || null;
    },
  },
  async mounted() {
    const plan = this.$route && this.$route.query ? this.$route.query.plan_id : null;
    const email = this.$route && this.$route.query ? this.$route.query.email : null;

    this.selectedPlanId = Array.isArray(plan) ? plan[0] : plan;

    const emailValue = Array.isArray(email) ? email[0] : email;

    if (emailValue && this.$refs.email) {
      this.$refs.email.value = emailValue;
    }

    await this.fetchRegisterPlans();
  },
  methods: {
    ...mapActions([
        "sendRegister"
    ]),
    async fetchRegisterPlans() {
      this.loadingPlans = true;

      await api.axios
        .get("/api/plans")
        .catch(() => {
          this.registerPlans = [];
        })
        .then((response) => {
          if (response && response.status === 200) {
            this.registerPlans = response.data;
          }
        });

      if (!this.selectedPlanId && this.availablePlans.length) {
        this.selectedPlanId = this.recommendedPlanId;
      }

      if (!this.availablePlans.some((plan) => String(plan.id) === String(this.selectedPlanId))) {
        this.selectedPlanId = this.recommendedPlanId;
      }

      this.loadingPlans = false;
    },
    formatPlanPrice(plan) {
      if (!plan) {
        return "";
      }

      const rawPrice = plan.price || plan.amount || plan.value || plan.monthly_price;
      const numericPrice = Number(rawPrice);

      if (!Number.isNaN(numericPrice) && rawPrice !== undefined && rawPrice !== null) {
        return numericPrice.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
      }

      return rawPrice ? String(rawPrice) : "";
    },
    formatPlanBillingCycle(plan) {
      const cycle = String(plan?.billing_cycle || plan?.interval || plan?.cycle || "monthly").toLowerCase();
      const cycleLabels = {
        month: "/mês",
        monthly: "/mês",
        mes: "/mês",
        year: "/ano",
        yearly: "/ano",
        ano: "/ano",
      };

      return cycleLabels[cycle] || "/mês";
    },
    changeInformationInputs(element){
      this.$refs[element].style.borderColor = "#dedee4";
    },
    applyMaskCpfCnpj(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 11) {
        value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      } else {
        value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }

      input.value = value;
    },
    applyMaskPhone(event) {
      const input = event.target;
      let value = input.value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      input.value = value;
    },
    hasLetters(str) {
      return /[a-zA-Z]/.test(str);
    },
    validateCaractersInputs(data){
      data.phone = data.phone.replace(/[!@#$(.) /-]/g, "");
      data.cpf_cnpj = data.cpf_cnpj.replace(/[!@#$(.) /-]/g, "");

      return data;
    },
    checkPassword(password){
      return /[0-9]/.test(password) && /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/.test(password);
    },
    submitRegister(){
      if (this.submitting || this.loadingPlans || !this.selectedPlanId) return;
      const formData = new FormData(this.$refs['formRegister']);
      var data = {};
      for (let [key, val] of formData.entries()) {
        Object.assign(data, { [key]: val })
      }

      data = this.validateCaractersInputs(data);

      if (this.selectedPlanId) {
        data.subscription_plan_id = this.selectedPlanId;
      }

      let error = false;
      if(data.name == ""){
        this.$refs["name"].style.borderColor = "red";
        error = true;
      }

      if(data.phone == "" || this.hasLetters(data.phone) || data.phone.length < 10){
        this.$refs["phone"].style.borderColor = "red";
        error = true;
      }
      
      if(data.cpf_cnpj == "" || this.hasLetters(data.cpf_cnpj) || (data.cpf_cnpj.length != 11 && data.cpf_cnpj.length != 14)){
        this.$refs["cpf_cnpj"].style.borderColor = "red";
        error = true;
      }
      
      if(data.email == ""){
        this.$refs["email"].style.borderColor = "red";
        error = true;
      }
      
      if(data.password == ""){
        this.$refs["password"].style.borderColor = "red";
        error = true;
      }
      
      if(data.confirm_password == ""){
        this.$refs["confirm_password"].style.borderColor = "red";
        error = true;
      }

      if(data.password != data.confirm_password){
        this.$refs["password"].style.borderColor = "red";
        this.$refs["confirm_password"].style.borderColor = "red";
        this.$refs["error_password_message"].style.display = "flex";
        error = true;
      } else {
        this.$refs["error_password_message"].style.display = "none";
      }

      if(!this.checkPassword(data.password)){
        this.$refs["error_password_message_caracters"].style.display = "flex";
        error = true;
      } else {
        this.$refs["error_password_message_caracters"].style.display = "none";
      }

      if(error){
        return;
      }

      this.submitting = true;
      this.sendRegister(data).finally(() => { this.submitting = false; });
    }
  }
};
</script>

<style scoped>
.register-trial-offer { margin: 24px 0; padding: 18px; background: #ecfaf2; border: 1px solid #b8e6ce; border-radius: 12px; color: #176b4c; text-align: center; }
.register-trial-offer strong, .register-trial-offer span { display: block; }
.register-trial-offer strong { font-size: 22px; margin-bottom: 6px; }
.register-trial-offer span { font-size: 14px; line-height: 1.5; }
.register-plan-selection { display: flex; align-items: center; gap: 10px; margin: 0; cursor: pointer; flex: 1; }
.register-plan-details { background: transparent; border: 0; text-decoration: underline; color: #08795c; min-height: 44px; font-size: 13px; padding: 4px; }
.plan-helper {
  color: #8a8a94;
  font-size: 12px;
  font-weight: 600;
}

.register-plan-list {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}

.register-plan-option {
  flex-direction: column;
  align-items: stretch;
  border: 1px solid #dedee4;
  border-radius: 7px;
  cursor: pointer;
  display: flex;
  gap: 10px;
  margin: 0;
  min-height: 58px;
  padding: 10px 12px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.register-plan-option.active {
  background: rgba(6, 180, 138, 0.06);
  border-color: #06b48a;
  box-shadow: 0 8px 20px rgba(6, 180, 138, 0.1);
}

.register-plan-option input {
  accent-color: #06b48a;
  flex: 0 0 auto;
}

.register-plan-option span,
.register-plan-option strong,
.register-plan-option small {
  display: block;
}

.register-plan-option strong {
  color: #202020;
  font-size: 14px;
  line-height: 1.2;
}

.register-plan-option small {
  color: #6b6b76;
  font-size: 12px;
  margin-top: 3px;
}
</style>
